import React, { useRef, useState, useEffect } from "react";
import { StringResources } from "./stringResources";

import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";


export function ReportViewer(
    { reportTrdp, parameters, accessToken, config, viewerRef } = {
        reportTrdp: null,
        parameters: {},
        accessToken: null,
        config: {},
        viewerRef: null,
    }
) {
    const [language, setLanguage] = useState(navigator.language);

    useEffect(() => {
        if (viewerRef) {
            const { viewerObject } = viewerRef.current;
            viewerObject.stringResources = Object.assign(viewerObject.stringResources, StringResources.custom);
        }
    }, [language])

    return (
        <TelerikReportViewer
                  ref={viewerRef}
                  authenticationToken={accessToken}
                  serviceUrl={config.REPORTS.SERVICE_URL}
                  reportSource={{
                    report: reportTrdp,
                    parameters: parameters,
                  }}
                  viewerContainerStyle={{
                    position: "absolute",
                    left: "20rem",
                    right: "2.5rem",
                    top: "1rem",
                    bottom: "7rem",
                    overflow: "auto",
                    clear: "both",
                    fontFamily: "Raleway, sans-serif",
                  }}
                  viewMode="INTERACTIVE"
                  scaleMode="SPECIFIC"
                  scale={1.0}
                  enableAccessibility={false}
                />
    )
}